const TRY_RATE_SESSION_KEY = "qpien_usd_try_rate"

interface StoredTryRate {
  rate: number
  timestamp: number
}

export async function getTryRate(): Promise<number> {
  try {
    const stored = sessionStorage.getItem(TRY_RATE_SESSION_KEY)
    if (stored) {
      const parsed: StoredTryRate = JSON.parse(stored)
      if (Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
        return parsed.rate
      }
    }
    const res = await fetch("https://open.er-api.com/v6/latest/USD")
    const data = await res.json()
    const rate = data?.rates?.TRY as number
    if (rate && rate > 0) {
      sessionStorage.setItem(
        TRY_RATE_SESSION_KEY,
        JSON.stringify({ rate, timestamp: Date.now() })
      )
      return rate
    }
  } catch {
    // silently fall back to no conversion
  }
  return 0
}

export function fmtUsd(n: number, minDecimals?: number): string {
  if (n === 0) return `$${(0).toFixed(minDecimals ?? 5)}`
  if (n < 0.000001) return `$${n.toFixed(Math.max(minDecimals ?? 0, 10))}`
  if (n < 0.0001) return `$${n.toFixed(Math.max(minDecimals ?? 0, 8))}`
  return `$${n.toFixed(minDecimals ?? 5)}`
}

export function fmtTry(usd: number, rate: number): string {
  if (!rate) return ""
  const tryVal = usd * rate
  if (tryVal === 0) return " (₺0.0000)"
  if (tryVal < 0.0001) return ` (₺${tryVal.toFixed(8)})`
  if (tryVal < 0.01) return ` (₺${tryVal.toFixed(6)})`
  return ` (₺${tryVal.toFixed(4)})`
}
